// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__eSJ6i","flex1":"App_flex1__1FQ-I","darkBg":"App_darkBg__2Fqq5","redBox":"App_redBox__3fcKC","timesButton":"App_timesButton__IhSQY"};